__turbopack_context__.v({
  "addButton": "zkovBq_addButton",
  "bottomContainer": "zkovBq_bottomContainer",
  "bulletSeparator": "zkovBq_bulletSeparator",
  "cardContainer": "zkovBq_cardContainer",
  "cardFadeIn": "zkovBq_cardFadeIn",
  "cardHeader": "zkovBq_cardHeader",
  "chevronButton": "zkovBq_chevronButton",
  "currentPrice": "zkovBq_currentPrice",
  "descriptionList": "zkovBq_descriptionList",
  "genderInfoContainer": "zkovBq_genderInfoContainer",
  "genderText": "zkovBq_genderText",
  "infoContainer": "zkovBq_infoContainer",
  "learnMoreLink": "zkovBq_learnMoreLink",
  "middleContainer": "zkovBq_middleContainer",
  "originalPrice": "zkovBq_originalPrice",
  "planNameText": "zkovBq_planNameText",
  "plusIcon": "zkovBq_plusIcon",
  "priceContainer": "zkovBq_priceContainer",
  "priceSection": "zkovBq_priceSection",
  "testsCount": "zkovBq_testsCount",
  "thumbnailContainer": "zkovBq_thumbnailContainer",
});
